import {
    FETCH_UPDATE_PRODUCT_REQUEST,
    FETCH_UPDATE_PRODUCT_SUCCESS,
    FETCH_UPDATE_PRODUCT_FAILURE,
    SET_UPDATE_PRODUCT
} from '../../actions/products/update-product-actions';

const initialState = {
    updatedProduct: null,
    product: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const UpdateProductReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_UPDATE_PRODUCT_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case SET_UPDATE_PRODUCT:
            return {
                ...state,
                isLoading: false,
                error: null,
                product: { ...action.payload }
            };
        case FETCH_UPDATE_PRODUCT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                updatedProduct: action.payload[0],
            };
        case FETCH_UPDATE_PRODUCT_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default UpdateProductReducer;